import type { ActionFunctionArgs } from '~/types/route-args';
import { data as routerData } from 'react-router';
import { handleBookingAction } from '~/modules-rocco/booking/api/handle-booking-action.server';
import { handleCancelAction } from '~/modules-rocco/booking/api/handle-cancel-action.server';

export const BOOKING_BOOK_API_ROUTE = '/remix-api/booking/book';

/**
 * Booking submission endpoint for the in-page booking modal. Reuses the same
 * server handlers the /booking page action uses, so booking and cancellation
 * behave identically whether triggered from the modal or the standalone page.
 */
export const action = async ({ request, context }: ActionFunctionArgs) => {
    const formData = await request.formData();
    const intent = formData.get('intent');

    if (intent === 'cancel') {
        const eventId = formData.get('eventId');
        if (!eventId || typeof eventId !== 'string') {
            return routerData(
                { ok: false, message: 'Event ID is required' },
                { status: 400 },
            );
        }
        return handleCancelAction(eventId, context);
    }

    if (intent !== 'book') {
        return routerData(
            { ok: false, message: 'Unsupported action' },
            { status: 400 },
        );
    }

    const searchParams = new URL(request.url).searchParams;
    const sendAsync =
        searchParams.get('async') === 'true' ||
        searchParams.get('sync') === 'false';

    return handleBookingAction(formData, context, sendAsync);
};
